export default __webpack_public_path__ + "static/media/united-kingdom.4839cec4.svg";